export default __webpack_public_path__ + "static/media/profile-kevin.bf6dde86.png";